import { Reveal, SectionHead } from "./Reveal";
import { scrollToId } from "../lib";

const MILESTONES = [
    {
        year: "1986",
        title: "The workshop years",
        text: "Science & Surgical is established in Kolkata, manufacturing hospital furniture and surgical equipment for a growing healthcare sector.",
    },
    {
        year: "1990s — 2000s",
        title: "Scale across the East",
        text: "Expanded to two branches and five manufacturing facilities, supplying hospitals and healthcare facilities across West Bengal, Assam and beyond.",
    },
    {
        year: "Today",
        title: "Design, R&D and a global network",
        text: "Active research and development in OT design and CSSD development — backed by partnerships with over 100 manufacturers across the globe for custom solutions.",
    },
];

export default function Legacy() {
    return (
        <section
            id="legacy"
            data-testid="legacy-section"
            className="relative py-24 lg:py-32"
        >
            <div className="mx-auto grid w-full max-w-7xl gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:gap-10 lg:px-8">
                <div className="lg:col-span-5">
                    <div className="lg:sticky lg:top-32">
                        <SectionHead
                            label="Our Legacy"
                            title="Three decades of operating-room engineering."
                        />
                        <Reveal delay={0.15}>
                            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-400">
                                From a Kolkata workshop to hospitals across
                                Eastern India — Science &amp; Surgical has
                                spent over three decades building the equipment
                                and the rooms that surgery depends on.
                            </p>
                        </Reveal>
                        <Reveal delay={0.25}>
                            <button
                                data-testid="legacy-products-cta"
                                onClick={() => scrollToId("products")}
                                className="group mt-8 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-accent"
                            >
                                See what we build
                                <span className="h-px w-8 bg-accent transition-all duration-300 group-hover:w-12" />
                            </button>
                        </Reveal>
                    </div>
                </div>

                <div className="lg:col-span-7">
                    {MILESTONES.map((m, i) => (
                        <Reveal key={m.year} delay={i * 0.08}>
                            <div
                                data-testid={`timeline-row-${i}`}
                                className="group flex flex-col gap-4 border-t border-line py-10 transition-all duration-500 last:border-b hover:bg-white/[0.02] sm:flex-row sm:gap-10 sm:px-4"
                            >
                                <span className="w-fit shrink-0 font-mono text-xs uppercase tracking-[0.25em] text-accent transition-all duration-300 group-hover:text-glow sm:w-40 sm:pt-1">
                                    {m.year}
                                </span>
                                <div>
                                    <h3 className="font-display text-xl font-bold text-white sm:text-2xl">
                                        {m.title}
                                    </h3>
                                    <p className="mt-3 max-w-lg text-sm leading-relaxed text-slate-400 sm:text-base">
                                        {m.text}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
